import { format } from 'date-fns';
import styled from 'styled-components';

import Text, { TextColor, TextVariant } from 'src/components/atoms/Text';
import { PreviousNote } from 'src/features/incomeVerification/api';

type PreviousNoteSummaryProps = {
  previousNote: PreviousNote | null;
};

const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 1rem;
  text-align: left;
`;

const NoteText = styled.p`
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

const PreviousNoteSummary = ({ previousNote }: PreviousNoteSummaryProps) => (
  <Block data-testid="previous-note">
    <Text variant={TextVariant.small} color={TextColor.gray700} isBold>
      Earlier note
    </Text>
    {previousNote ? (
      <>
        <NoteText>{previousNote.text}</NoteText>
        <Text variant={TextVariant.small} color={TextColor.gray600}>
          {`${previousNote.author_name ?? 'Unknown analyst'} · ${format(
            new Date(previousNote.created_at),
            'MM/dd/yyyy'
          )}`}
        </Text>
      </>
    ) : (
      <Text variant={TextVariant.small} color={TextColor.gray600}>
        No note recorded
      </Text>
    )}
  </Block>
);

export default PreviousNoteSummary;
